import ProductPromo from './ProductPromo';

export default ProductPromo;
